import { FC } from 'react'

interface IProps {
  errorMessage: string
  validationWarning: string
}

const ErrorMessages: FC<IProps> = ({ errorMessage, validationWarning }) => {
  return (
    <>
      {!!errorMessage && (
        <div className='alert alert-danger maxedbox'>{errorMessage}</div>
      )}
      {!!validationWarning && (
        <div className='alert alert-danger maxedbox'>{validationWarning}</div>
      )}
    </>
  )
}

export default ErrorMessages
